import React, { useState } from "react";

import { faUpload } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import mainAxios from "../../../services/mainAxios";
import Loader from "../../Layout/Loader";
import { Dialog } from "primereact/dialog";
import { useAppContext } from "../../../AppContext";
import PreviewReferenceData from "./PreviewReferenceData";
import func from "../../../services/functions";
import "./importSuppliers.scss";

const ImportSuppliers = ({
    visible,
    onHide,
    onSuccess
  }) => {
    const { t } = useTranslation("translations");
    const [state, setState] = React.useState({
      file: null,
      name: null,
      extension: "",
    });
    const [previewVisible, setPreviewVisible] = useState(false);

    const {
        user: [user, setUser],
        selectedCompany: [selectedCompany, setSelectedCompany],
      } = useAppContext();


    const [loading, setLoading] = React.useState(false);
  
    const submitSuppliers = (e) => {
      e.preventDefault();
      setLoading(true);
  
      mainAxios
        .post("apiEndpoint/saveOrUpdate", {
          object: "UploadConnections",
          content: {
            file: state.file,
          },
          nuis: user.companiesRights.find(
            (company) => company.id === parseInt(selectedCompany)
          )?.nuis,
          username: user.username,
          company: selectedCompany
        })
        .then((res) => {
          if (res?.data?.status === true) {
            toast.success(res.data.message || t("notification.success"), {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              progress: undefined,
              containerId: "all_toast",
            });
            onSuccess();
          }
          setLoading(false);
        })
        .catch(() => {
          setLoading(false);
        });
    };
  
    const handleFile = (e) => {
      const file = e.target.files[0];
      const extension =
        file && file.name.split(".")[file.name.split(".").length - 1];
      const maxFileSize = 5 * 1024 * 1024; // 5MB in bytes

      if (file && file.size > maxFileSize) {
        toast.error(t("notification.fileSizeExceeded") || "File size exceeds 5MB limit", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          progress: undefined,
          containerId: "all_toast",
        });
        return;
      }

      if (extension && extension === "csv") {
        const reader = new FileReader();

        reader.onload = (readerEvent) => {
          let binaryString = readerEvent.target.result;
          setState((state) => ({
            ...state,
            file: btoa(binaryString),
            name: file.name,
            extension,
          }));
        };
        reader.readAsBinaryString(file);
      }
    };
  
  
  return (
    <>
      <Dialog
        header={t("mySuppliers.importSupplier")}
        visible={visible}
        onHide={onHide}
        style={{ width: "28vw" }}
        breakpoints={{ "960px": "75vw", "641px": "100vw" }}
      >
        <form onSubmit={submitSuppliers}>
          <div className="form-group">
            <div style={{
              backgroundColor: "#fffbea",
              border: "1px solid #ffe58f",
              borderRadius: "4px",
              padding: "0.75rem 1rem",
              marginBottom: "1rem"
            }}>
              <p style={{ marginBottom: "0.2rem", color: "#664d03", fontSize: "0.9rem", fontWeight: "500" }}>
                {t("common.formatdocument")} (CSV)
              </p>
              <p style={{ marginBottom: "0", color: "#664d03", fontSize: "0.85rem" }}>
                Max file size: 5mb
              </p>
            </div>
            <label htmlFor="supplierFile" style={{ fontWeight: "500", marginBottom: "0.5rem" }}>{t("invoice.file")}</label>
            <input
              type="file"
              className="form-control"
              id="file"
              name="file"
              placeholder="Upload File"
              accept=".csv"
              onClick={(e) => {
                e.target.value = null;
              }}
              onChange={handleFile}
            />
            {state.name && <small className="text-muted mt-1 d-block">{state.name}</small>}
          </div>

          <div className="import-templates-section mt-4">
            <p className="import-section-title">
              <strong>{t("exports.templates")}</strong>
            </p>

            <div className="import-templates-info">
              <p className="info-text">
                <small>• {t("exports.referenceDataInfo")}</small>
              </p>
              <p className="info-text">
                <small>• {t("exports.contactTypeDescription")}</small>
              </p>
              <p className="info-text">
                <small>• {t("exports.bankAccountDescritpion")}</small>
              </p>
            </div>

            <div className="templates-grid">
              <a
                href="/_supplier_csv_template.csv"
                className="btn btn-sm btn-outline-primary"
                download="/_supplier_csv_template.csv"
              >
                <i className="pi pi-download mr-2"></i>
                {t("exports.importTemplate")}
              </a>

              <button
                type="button"
                className="btn btn-sm btn-outline-primary"
                onClick={() => setPreviewVisible(true)}
                title="Preview Reference Data"
              >
                <i className="pi pi-eye mr-2"></i>
                 {t("exports.referenceData")}
              </button>
            </div>
          </div>

          <button
            className="btn btn-primary mt-3"
            disabled={loading || !state.file}
            style={{ minWidth: "80px" }}
            type="submit"
          >
            {loading ? (
              <Loader size="xs" color="white" />
            ) : (
              <>
                <FontAwesomeIcon icon={faUpload} className="mr-2" />
                {t("common.import")}
              </>
            )}
          </button>
        </form>
      </Dialog>

      <PreviewReferenceData
        visible={previewVisible}
        onHide={() => setPreviewVisible(false)}
      />
    </>
  );
  };
  
  export default ImportSuppliers;